module.exports = __webpack_public_path__ + "static/media/blazer_left_img.9d15cf09.png";